const common = {
  acadly_attachment_file_name: 'Acadly attachment: {{fileName}}',
  click_to_get_download_url_of_attachment: 'click to get download URL of attachment',
  click_to_download_attachment: 'click to download attachment',
  click_to_download_file: 'click to download file',

  click_to_go_back: 'click to go back',
  click_to_close_dialog: 'click to close dialog',
  click_to_close_drawer: 'click to close drawer',

  there_was_an_error_loading_this_image: 'There was an error loading this image',
  this_is_a_big_image_of_size_mb_and_may_take_some_time_to_load:
    'This is a big image of {{size}} MB and may take some time to load',

  csv_download: 'CSV Download',
  email_attachment: 'Email Attachment',
  file_generated: 'File generated',
  file_mailed: 'File mailed!',
  the_exported_file_has_been_mailed_to_your_registered_email_address_in_case_you_can_t_spot_it_please_look_into_your_spam_folder:
    "The exported file has been mailed to your registered email address. In case you can't spot it, please look into your spam folder.",
  download_a_copy: 'Download a copy',
  click_to_select_csv_download: 'click to select csv download',
  click_to_select_email_attachment: 'click to select email attachment',
  click_to_download_a_copy: 'click to download a copy',

  zoom_enabled_course: 'Zoom enabled course',

  click_to_use_this_formula: 'Click to use this formula',
  inserting_math_expression: 'Inserting math expression',
  as_you_type_the_expression_in_the_input_box_below_the_formatted_output_will_appear_here:
    'As you type the expression in the input box below, the formatted output will appear here',
  enter_formula_here: 'Enter formula here',
  format_and_display: 'Format and display',
  input_format: 'Input format',
  output_display_style: 'Output display style',
  click_to_delete_attachment: 'click to delete attachment',

  click_to_toggle_password_visibility: 'click to toggle password visibility',
  some_error_occurred_please_try_again_later_if_the_issue_persists_please_contact_us_at_support_email:
    'Some error occured, please try after sometime. If the issue persists, please contact us at support@acadly.com',

  N_seconds: '{{count}} seconds',
  N_minutes: '{{count}} minutes',

  /** slide Title and subTitle */

  acadly_activity_plugin: 'ACADLY ACTIVITY PLUGIN',
  acadly_activity_plugin_course_code: `ACADLY ACTIVITY PLUGIN \r {{courseCode}}`,

  /** Floating notification */
  press_esc_to_start_navigating_between_slides: 'Press <1>Esc</1> to start navigating between slides.',
  press_arrow_key_left_icon_arrow_key_right_icon_to_navigate_between_slides:
    'Press <1>arrow-key-left-icon</1> <3>arrow-key-right-icon</3> to navigate between slides.',

  /** Error Fallback UI */
  something_went_wrong: 'Something went wrong',
  try_again: 'Try again',
};

export default common;
